import type { Store } from '../../../types/codexOrder';
import { ChevronLeftIcon, HeadsetIcon } from '../../../assets/Icons';

function OrderSupport({ store }: { store: Store }) {
  if (!store?.phone) return null;

  return (
    <div className="p-4 rounded-lg bg-white mb-4">
      <div className="flex items-center gap-x-2 mb-3">
        <HeadsetIcon className="text-brand-icon" />
        <p className="font-bold">Support</p>
      </div>
      <p
        onClick={() => {
          if (store?.phone) {
            window.location.href = `tel:${store?.phone}`;
          }
        }}
        className="text-brand-icon text-sm cursor-pointer flex items-center max-w-max">
        <span>Call the restaurant</span>
        <ChevronLeftIcon className="w-4 h-4 rotate-180 mt-0.5" />
      </p>
    </div>
  );
}

export default OrderSupport;
